import LeftPaneQuoteResults from "../general/LeftPaneQuoteResults";
import RightPaneActions from "../general/RightPaneActions";
import * as theme from "../theme";

const TwoPanesPanel = (props) => {
  let leftPane = props.leftPane ? (
    props.leftPane
  ) : (
    <LeftPaneQuoteResults></LeftPaneQuoteResults>
  );
  let rightPane = props.rightPane ? (
    props.rightPane
  ) : (
    <RightPaneActions></RightPaneActions>
  );

  // for showing myqutoes
  if (props.myquotesscreen) {
    leftPane = props.myquotesleftpane;
    rightPane = props.myquotesrightpane;
  }

  const leftPaneWidth = props.leftPaneWidth ?? theme.SCALES.quotesLeftPaneWidth;
  let rightPaneWidth =  props.rightPaneWidth ?? theme.SCALES.quotesRightPaneWidth;

  if (props.welcomebackscreen) {
    leftPaneWidth = "75%";
    rightPaneWidth = `calc(100% - ${leftPaneWidth})`;
  }
  return (
    <div style={{ display: "flex", height: "100%", width: "100%" }}>
      <div
        style={{
          width: leftPaneWidth,
          height: "100%",
          overflowY: props.overflowY ? props.overflowY : "auto",
          backgroundColor: theme.COLORS.tertiary_lightbackground,
          // boxShadow: "20px 20px 30px 0px #AFB6CC",
          zIndex: 2,
        }}
      >
        {leftPane}
      </div>
      <div
        style={{
          width: rightPaneWidth,
          height: props.height ? props.height : "100%",
          zIndex: 1,
          backgroundColor: theme.COLORS.tertiary_lightbackground,
        }}
      >
        {rightPane}
      </div>
    </div>
  );
};

export default TwoPanesPanel;
